class ArticleFeaturedProducts {
  constructor(section) {
    this.section = section;
    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    this.bindVariantSelectors();
    this.bindProductForms();
  }

  bindVariantSelectors() {
    this.section.querySelectorAll('[data-article-product]').forEach((card) => {
      const variantSelect = card.querySelector('[data-variant-select]');
      const variantInput = card.querySelector('[data-variant-id-input]');
      const addButton = card.querySelector('[data-add-to-cart]');
      const buttonText = card.querySelector('[data-add-button-text]');

      if (!variantSelect || !variantInput) return;

      variantSelect.addEventListener('change', () => {
        const selectedOption =
          variantSelect.options[variantSelect.selectedIndex];

        const isAvailable = selectedOption.dataset.available === 'true';

        variantInput.value = selectedOption.value;

        if (addButton) {
          addButton.disabled = !isAvailable;
        }

        if (buttonText) {
          buttonText.textContent = isAvailable
            ? window.variantStrings?.addToCart || 'Add to cart'
            : window.variantStrings?.soldOut || 'Sold out';
        }
      });
    });
  }

  bindProductForms() {
    this.section
      .querySelectorAll('[data-article-product-form]')
      .forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          const card = form.closest('[data-article-product]');
          const addButton = form.querySelector('[data-add-to-cart]');
          const spinner = addButton?.querySelector('.loading__spinner');
          const errorBox = form.querySelector('[data-product-error]');

          if (!addButton || addButton.disabled) return;

          this.clearError(errorBox);
          addButton.setAttribute('aria-disabled', 'true');
          addButton.classList.add('loading');
          spinner?.classList.remove('hidden');

          try {
            const formData = new FormData(form);

            if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
              formData.append(
                'sections',
                this.cart
                  .getSectionsToRender()
                  .map((section) => section.id)
              );

              formData.append(
                'sections_url',
                window.location.pathname
              );

              if (typeof this.cart.setActiveElement === 'function') {
                this.cart.setActiveElement(document.activeElement);
              }
            } else {
              formData.append(
                'sections',
                'cart-notification-product,cart-notification-button,cart-icon-bubble'
              );

              formData.append('sections_url', window.location.pathname);
            }

            const response = await fetch(
              window.routes?.cart_add_url || '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  Accept: 'application/javascript',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
              }
            );

            const result = await response.json();

            if (!response.ok || result.status) {
              throw new Error(
                result.description ||
                result.message ||
                'This product could not be added to the cart.'
              );
            }

            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(result);
            } else {
              await this.refreshCartNotification(result);
            }

            this.publishCartUpdate(result, card);
          } catch (error) {
            this.showError(
              errorBox,
              error.message || 'Something went wrong. Please try again.'
            );
          } finally {
            addButton.classList.remove('loading');
            addButton.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          }
        });
      });
  }

  async refreshCartNotification(result) {
    const cartNotification = document.querySelector('cart-notification');

    if (!cartNotification) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }

    if (
      result.sections &&
      typeof cartNotification.renderContents === 'function'
    ) {
      cartNotification.renderContents(result);
      return;
    }

    window.location.href = window.routes?.cart_url || '/cart';
  }

  publishCartUpdate(result, sourceElement) {
    if (
      typeof publish !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined'
    ) {
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'article-featured-products',
      productVariantId: result.variant_id || result.id,
      cartData: result,
      sourceElement
    });
  }

  showError(errorBox, message) {
    if (!errorBox) return;

    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  clearError(errorBox) {
    if (!errorBox) return;

    errorBox.textContent = '';
    errorBox.hidden = true;
  }
}

function initializeArticleFeaturedProducts(container = document) {
  container
    .querySelectorAll('[id^="ArticleFeaturedProducts-"]')
    .forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';
      new ArticleFeaturedProducts(section);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeArticleFeaturedProducts();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeArticleFeaturedProducts(event.target);
});